import { render, staticRenderFns } from "./Domains.vue?vue&type=template&id=6c19611c&scoped=true"
import script from "./Domains.vue?vue&type=script&lang=js"
export * from "./Domains.vue?vue&type=script&lang=js"
import style0 from "./Domains.vue?vue&type=style&index=0&id=6c19611c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c19611c",
  null
  
)

export default component.exports